import { env, apimKey } from "../../../config";
import { lang } from "../../../i18n";
import sortObjLocaleBy from "../../../utils/sortObjLocaleBy";
import log from "../../../utils/log";

export default async function fetchCitiesAsync() {
  const baseUrl = `https://apim-ikeasa.azure-api.net/AreaList/${env}/`;
  const response = await fetch(baseUrl, {
    headers: {
      "Ocp-Apim-Subscription-Key": apimKey,
    },
  });

  if (response.status === 200) {
    const json = await response.json();
    log("fetchCitiesAsync", "response", json);

    const cities = json.Region_Area.filter((area) => area.Type === "City");

    // alphabitical sort
    const prop = lang === "ar" ? "LocalizedName" : "Name";
    return cities.sort(sortObjLocaleBy(prop, lang));
  }

  throw new Error(response.status);
}

/*
[
  {
    "Id": "191",
    "Code": "01061",
    "Name": "Al Kharj",
    "Type": "City",
    "ParentCode": "01",
    "LocalizedName": "الخرج",
    "CountryId": 238
  },
  {
    "Id": "202",
    "Code": "00003",
    "Name": "Riyadh",
    "Type": "City",
    "ParentCode": "01",
    "LocalizedName": "الرياض",
    "CountryId": 238
  },
  {
    "Id": "213",
    "Code": "00018",
    "Name": "Jeddah",
    "Type": "City",
    "ParentCode": "02",
    "LocalizedName": "جدة",
    "CountryId": 238
  },
  {
    "Id": "214",
    "Code": "01105",
    "Name": "Khulais",
    "Type": "City",
    "ParentCode": "02",
    "LocalizedName": "خليص",
    "CountryId": 238
  },
  {
    "Id": "215",
    "Code": "03666",
    "Name": "King Abdullah Economic City",
    "Type": "City",
    "ParentCode": "02",
    "LocalizedName": "مدينة الملك عبدالله الاقتصادية",
    "CountryId": 238
  },
  {
    "Id": "216",
    "Code": "00006",
    "Name": "Makkah",
    "Type": "City",
    "ParentCode": "02",
    "LocalizedName": "مكة المكرمة",
    "CountryId": 238
  },
  {
    "Id": "217",
    "Code": "00377",
    "Name": "Rabigh",
    "Type": "City",
    "ParentCode": "02",
    "LocalizedName": "رابغ",
    "CountryId": 238
  },
  {
    "Id": "219",
    "Code": "00005",
    "Name": "Taif",
    "Type": "City",
    "ParentCode": "02",
    "LocalizedName": "الطائف",
    "CountryId": 238
  },
  {
    "Id": "220",
    "Code": "01879",
    "Name": "Thuwal",
    "Type": "City",
    "ParentCode": "02",
    "LocalizedName": "ثول",
    "CountryId": 238
  },
  {
    "Id": "230",
    "Code": "01053",
    "Name": "Badr",
    "Type": "City",
    "ParentCode": "03",
    "LocalizedName": "بدر",
    "CountryId": 238
  },
  {
    "Id": "232",
    "Code": "00014",
    "Name": "Madinah",
    "Type": "City",
    "ParentCode": "03",
    "LocalizedName": "المدينة المنورة",
    "CountryId": 238
  },
  {
    "Id": "234",
    "Code": "00483",
    "Name": "Yanbu",
    "Type": "City",
    "ParentCode": "03",
    "LocalizedName": "ينبع",
    "CountryId": 238
  },
  {
    "Id": "235",
    "Code": "09605",
    "Name": "Yanbu Al Sinaiyah",
    "Type": "City",
    "ParentCode": "03",
    "LocalizedName": "ينبع الصناعية",
    "CountryId": 238
  },
  {
    "Id": "238",
    "Code": "02481",
    "Name": "Al Badayea",
    "Type": "City",
    "ParentCode": "04",
    "LocalizedName": "البدائع",
    "CountryId": 238
  },
  {
    "Id": "239",
    "Code": "02630",
    "Name": "Al Bukayriyah",
    "Type": "City",
    "ParentCode": "04",
    "LocalizedName": "البكيرية",
    "CountryId": 238
  },
  {
    "Id": "240",
    "Code": "02629",
    "Name": "Al Hilaliyah",
    "Type": "City",
    "ParentCode": "04",
    "LocalizedName": "الهلالية",
    "CountryId": 238
  },
  {
    "Id": "242",
    "Code": "02448",
    "Name": "Al Mithnab",
    "Type": "City",
    "ParentCode": "04",
    "LocalizedName": "المذنب",
    "CountryId": 238
  },
  {
    "Id": "244",
    "Code": "02421",
    "Name": "Ar Rass",
    "Type": "City",
    "ParentCode": "04",
    "LocalizedName": "الرس",
    "CountryId": 238
  },
  {
    "Id": "246",
    "Code": "00011",
    "Name": "Buraydah",
    "Type": "City",
    "ParentCode": "04",
    "LocalizedName": "بريدة",
    "CountryId": 238
  },
  {
    "Id": "247",
    "Code": "02467",
    "Name": "Riyadh Al Khabra",
    "Type": "City",
    "ParentCode": "04",
    "LocalizedName": "رياض الخبراء",
    "CountryId": 238
  },
  {
    "Id": "248",
    "Code": "00080",
    "Name": "Unayzah",
    "Type": "City",
    "ParentCode": "04",
    "LocalizedName": "عنيزة",
    "CountryId": 238
  },
  {
    "Id": "249",
    "Code": "01999",
    "Name": "Uyun Al Jawa",
    "Type": "City",
    "ParentCode": "04",
    "LocalizedName": "عيون الجواء",
    "CountryId": 238
  },
  {
    "Id": "251",
    "Code": "00012",
    "Name": "Al Hofuf",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "الهفوف",
    "CountryId": 238
  },
  {
    "Id": "253",
    "Code": "00113",
    "Name": "Al Jubail",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "الجبيل",
    "CountryId": 238
  },
  {
    "Id": "255",
    "Code": "00031",
    "Name": "Al Khobar",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "الخبر",
    "CountryId": 238
  },
  {
    "Id": "257",
    "Code": "00067",
    "Name": "Al Qatif",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "القطيف",
    "CountryId": 238
  },
  {
    "Id": "258",
    "Code": "02171",
    "Name": "Anak",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "عنك",
    "CountryId": 238
  },
  {
    "Id": "259",
    "Code": "00243",
    "Name": "Buqayq",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "بقيق",
    "CountryId": 238
  },
  {
    "Id": "260",
    "Code": "00013",
    "Name": "Dammam",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "الدمام",
    "CountryId": 238
  },
  {
    "Id": "261",
    "Code": "00227",
    "Name": "Dhahran",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "الظهران",
    "CountryId": 238
  },
  {
    "Id": "262",
    "Code": "00047",
    "Name": "Hafar Al Batin",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "حفر الباطن",
    "CountryId": 238
  },
  {
    "Id": "267",
    "Code": "02167",
    "Name": "Safwa",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "صفوى",
    "CountryId": 238
  },
  {
    "Id": "268",
    "Code": "02590",
    "Name": "Ras Tanurah",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "راس تنورة",
    "CountryId": 238
  },
  {
    "Id": "269",
    "Code": "00454",
    "Name": "Saihat",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "سيهات",
    "CountryId": 238
  },
  {
    "Id": "270",
    "Code": "00456",
    "Name": "Tarout",
    "Type": "City",
    "ParentCode": "05",
    "LocalizedName": "تاروت",
    "CountryId": 238
  },
  {
    "Id": "271",
    "Code": "00015",
    "Name": "Abha",
    "Type": "City",
    "ParentCode": "06",
    "LocalizedName": "ابها",
    "CountryId": 238
  },
  {
    "Id": "272",
    "Code": "02213",
    "Name": "Arar",
    "Type": "City",
    "ParentCode": "09",
    "LocalizedName": "عرعر",
    "CountryId": 238
  },
  {
    "Id": "273",
    "Code": "03658",
    "Name": "Baish",
    "Type": "City",
    "ParentCode": "10",
    "LocalizedName": "بيش",
    "CountryId": 238
  },
  {
    "Id": "275",
    "Code": "00065",
    "Name": "Ahad Rafidah",
    "Type": "City",
    "ParentCode": "06",
    "LocalizedName": "احد رفيده",
    "CountryId": 238
  },
  {
    "Id": "280",
    "Code": "01514",
    "Name": "Bisha",
    "Type": "City",
    "ParentCode": "06",
    "LocalizedName": "بيشة",
    "CountryId": 238
  },
  {
    "Id": "282",
    "Code": "00062",
    "Name": "Khamis Mushait",
    "Type": "City",
    "ParentCode": "06",
    "LocalizedName": "خميس مشيط",
    "CountryId": 238
  },
  {
    "Id": "285",
    "Code": "03328",
    "Name": "Sarat Abidah",
    "Type": "City",
    "ParentCode": "06",
    "LocalizedName": "سراة عبيدة",
    "CountryId": 238
  },
  {
    "Id": "288",
    "Code": "03678",
    "Name": "Tendaha",
    "Type": "City",
    "ParentCode": "06",
    "LocalizedName": "تندحة",
    "CountryId": 238
  },
  {
    "Id": "295",
    "Code": "00001",
    "Name": "Tabuk",
    "Type": "City",
    "ParentCode": "07",
    "LocalizedName": "تبوك",
    "CountryId": 238
  },
  {
    "Id": "311",
    "Code": "03597",
    "Name": "Al Aridhah",
    "Type": "City",
    "ParentCode": "10",
    "LocalizedName": "العارضة",
    "CountryId": 238
  },
  {
    "Id": "312",
    "Code": "03657",
    "Name": "Al Edabi",
    "Type": "City",
    "ParentCode": "10",
    "LocalizedName": "العيدابى",
    "CountryId": 238
  },
  {
    "Id": "316",
    "Code": "00017",
    "Name": "Jazan",
    "Type": "City",
    "ParentCode": "10",
    "LocalizedName": "جازان",
    "CountryId": 238
  },
  {
    "Id": "318",
    "Code": "03417",
    "Name": "Najran",
    "Type": "City",
    "ParentCode": "11",
    "LocalizedName": "نجران",
    "CountryId": 238
  },
  {
    "Id": "322",
    "Code": "03663",
    "Name": "Al Harth",
    "Type": "City",
    "ParentCode": "10",
    "LocalizedName": "الحرث",
    "CountryId": 238
  },
  {
    "Id": "323",
    "Code": "03418",
    "Name": "Badr Al Janoub",
    "Type": "City",
    "ParentCode": "11",
    "LocalizedName": "بدر الجنوب",
    "CountryId": 238
  },
  {
    "Id": "325",
    "Code": "03420",
    "Name": "Khbash",
    "Type": "City",
    "ParentCode": "11",
    "LocalizedName": "خباش",
    "CountryId": 238
  },
  {
    "Id": "327",
    "Code": "02522",
    "Name": "Yadamah",
    "Type": "City",
    "ParentCode": "11",
    "LocalizedName": "يدمة",
    "CountryId": 238
  },
  {
    "Id": "328",
    "Code": "03421",
    "Name": "Thar",
    "Type": "City",
    "ParentCode": "11",
    "LocalizedName": "ثار",
    "CountryId": 238
  },
  {
    "Id": "330",
    "Code": "01542",
    "Name": "Al Bahah",
    "Type": "City",
    "ParentCode": "12",
    "LocalizedName": "الباحة",
    "CountryId": 238
  },
  {
    "Id": "334",
    "Code": "01546",
    "Name": "Baljurashi",
    "Type": "City",
    "ParentCode": "12",
    "LocalizedName": "بلجرشي",
    "CountryId": 238
  },
  {
    "Id": "338",
    "Code": "02237",
    "Name": "Sakaka",
    "Type": "City",
    "ParentCode": "13",
    "LocalizedName": "سكاكا",
    "CountryId": 238
  },
  {
    "Id": "341",
    "Code": "03422",
    "Name": "Al Kharkhir",
    "Type": "City",
    "ParentCode": "11",
    "LocalizedName": "الخرخير",
    "CountryId": 238
  },
  {
    "Id": "42",
    "Code": "0411",
    "Name": "Al Bahah",
    "Type": "City",
    "ParentCode": "94",
    "LocalizedName": "الباحة",
    "CountryId": 238
  },
  {
    "Id": "7",
    "Code": "0102",
    "Name": "Makkah",
    "Type": "City",
    "ParentCode": "91",
    "LocalizedName": "مكة المكرمة",
    "CountryId": 238
  },
  {
    "Id": "9",
    "Code": "0401",
    "Name": "Madinah",
    "Type": "City",
    "ParentCode": "91",
    "LocalizedName": "المدينة المنورة",
    "CountryId": 238
  }
]

*/
